import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui';
import { t } from '@/i18n';

/** Onayın hatırlandığı anahtar — yalnızca bandı gizlemek için, izleme amacı yok. */
const STORAGE_KEY = 'biyolink.cookie-notice';

/**
 * Çerez bilgilendirme bandı (docs/07 Faz 7 madde 6).
 *
 * Rıza TOPLAMAZ, yalnız bilgilendirir: platformda sadece oturum için zorunlu çerezler
 * kullanılıyor, bunlar için açık rıza gerekmiyor. Bu yüzden "reddet" seçeneği de yok —
 * reddedilebilecek bir izleme çerezi bulunmuyor.
 */
/** Bant hâlâ görünecek mi — sabit WhatsApp düğmesi konumunu buna göre seçiyor. */
export function cookieNoticePending(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === null;
  } catch {
    return false;
  }
}

export function CookieBanner({ onDismiss }: { onDismiss?: () => void }) {
  // İlk değer doğrudan localStorage'dan okunur: effect ile setState zinciri kurmaya
  // gerek yok (SPA olduğumuz için sunucu tarafı render uyuşmazlığı da yok).
  const [dismissed, setDismissed] = useState(
    () => window.localStorage.getItem(STORAGE_KEY) !== null,
  );

  if (dismissed) return null;

  function dismiss(): void {
    window.localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    setDismissed(true);
    onDismiss?.();
  }

  return (
    <div
      role="region"
      aria-label={t('cookieBanner.policy')}
      className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-surface/95 backdrop-blur"
    >
      <div className="container-page flex flex-wrap items-center gap-3 py-3">
        <p className="min-w-0 flex-1 text-sm text-slate-600">
          {t('cookieBanner.text')}{' '}
          <Link to="/sayfa/cerez-politikasi" className="text-primary-900 underline">
            {t('cookieBanner.policy')}
          </Link>
        </p>
        <Button size="sm" onClick={dismiss}>
          {t('cookieBanner.accept')}
        </Button>
      </div>
    </div>
  );
}
